import { SoundController } from "@hg/media"

import { bgm } from "./bgm"

const KEY_MUTE = "AK_ACT_FES_SPRING_MUTE"

export const getIsMute = () => !localStorage.getItem(KEY_MUTE)
export const setMusicMute = () => localStorage.setItem(KEY_MUTE, "1")
export const unsetMusicMute = () => localStorage.removeItem(KEY_MUTE)

export const soundController = new SoundController({
    initEnable: getIsMute(),
    sounds: [bgm],
})
